import React from 'react';

export default function Logo({ size = 34 }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <circle cx="28" cy="28" r="25" fill="none" stroke="#3FD39A" strokeOpacity=".3" strokeWidth="1.5"/>
      <g>
        <circle cx="53" cy="28" r="4" fill="#3FD39A"/>
        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
          from="0 28 28" to="360 28 28" dur="5s" repeatCount="indefinite"/>
      </g>
      <circle cx="28" cy="28" r="20" fill="none" stroke="#fff" strokeWidth="6"/>
      <rect x="18.6" y="31" width="3" height="6" rx="1" fill="#fff"/>
      <rect x="23.8" y="26" width="3" height="11" rx="1" fill="#fff"/>
      <rect x="29"   y="22" width="3" height="15" rx="1" fill="#fff"/>
      <rect x="34.2" y="17" width="3" height="20" rx="1" fill="#3FD39A"/>
      <line x1="40" y1="40" x2="52" y2="52" stroke="#fff" strokeWidth="6" strokeLinecap="round"/>
    </svg>
  );
}
